// extracted by mini-css-extract-plugin
module.exports = {"editor":"wysiwyg_editor__3fmhx","editorContainer":"wysiwyg_editorContainer__2Ui2Z"};